<template>
  <div>
    <v-layout wrap justify-right class="mt-3 mb-3">
      <v-flex xs12 sm8>
        <v-btn
          small
          :outline="currentFilter != 'today'"
          :color="currentFilter == 'today' ? 'primary' : 'grey'"
          depressed
          class="ma-0 mr-1 mb-1"
          @click="changeDate('today')"
          >{{ $t('today') }}</v-btn
        >
        <v-btn
          small
          :outline="currentFilter != 'this_month'"
          :color="currentFilter == 'this_month' ? 'primary' : 'grey'"
          depressed
          class="ma-0 mr-1 mb-1"
          @click="changeDate('this_month')"
          >{{ $t('this month') }}</v-btn
        >
        <v-btn
          small
          :outline="currentFilter != 'this_year'"
          :color="currentFilter == 'this_year' ? 'primary' : 'grey'"
          depressed
          class="ma-0 mr-1 mb-1"
          @click="changeDate('this_year')"
          >{{ $t('this year') }}</v-btn
        >
        <v-btn
          small
          :outline="currentFilter != 'last_month'"
          :color="currentFilter == 'last_month' ? 'primary' : 'grey'"
          depressed
          class="ma-0 mr-1 mb-1"
          @click="changeDate('last_month')"
          >{{ $t('last 30 days') }}</v-btn
        >
        <v-btn
          small
          :outline="currentFilter != 'last_365_day'"
          :color="currentFilter == 'last_365_day' ? 'primary' : 'grey'"
          depressed
          class="ma-0 mr-1 mb-1"
          @click="changeDate('last_365_day')"
          >{{ $t('last 365 days') }}</v-btn
        >
        <!-- <v-btn
          small
          :outline="currentFilter != 'custom_date'"
          :color="currentFilter == 'custom_date' ? 'primary' : 'grey'"
          depressed
          class="ma-0 mr-1 mb-1"
          @click="changeDate('custom_date')"
        >{{$t('Custom Date')}}</v-btn>-->
      </v-flex>
      <v-flex xs12 sm4>
        <div class="form-control">
          <input type="text" name id :placeholder="$t('Search')" v-model="search" />
        </div>
      </v-flex>
      <v-flex></v-flex>
    </v-layout>
    <!-- <v-layout>
      <v-flex>
        <v-dialog
          ref="dialog"
          v-model="startdateModal"
          :return-value.sync="selectedDate.start"
          persistent
          lazy
          full-width
          width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="selectedDate.start"
              :label="$t('from')"
              prepend-icon="event"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="selectedDate.start" scrollable>
            <v-spacer></v-spacer>
            <v-btn flat color="primary" @click="startdateModal = false">Cancel</v-btn>
            <v-btn
              flat
              color="primary"
              @click="$refs.dialog.save(selectedDate.start);onSelectedStartDate()"
            >OK</v-btn>
          </v-date-picker>
        </v-dialog>
      </v-flex>
      <v-flex>
        <span class="dashboard_datepicker" style="margin-bottom: 10px;">
          {{$t('to')}}:
          <!- <datepicker v-model="selectedDate.end" style @selected="onSelectedEndDate"></datepicker> ->
        </span>
      </v-flex>
    </v-layout>-->
    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="admins"
      class="elevation-1"
      :search="search"
      expand
      item-key="first_name"
      :rows-per-page-items="[25, 35, 50, { text: $t('All'), value: -1 }]"
      :pagination.sync="pagination"
      :rows-per-page-text="$t('Rows per page')"
    >
      <template v-slot:items="props">
        <tr @click="props.expanded = !props.expanded">
          <td>
            <v-avatar size="30" class="mr-2">
              <img :src="props.item.profile_pic" width="30" height="30" />
            </v-avatar>
            {{ props.item.first_name }}
          </td>
          <td class="text-xs-center">{{ props.item.totaltasks | numberFormat }}</td>
          <td class="text-xs-center">{{ props.item.closetasks | numberFormat }}</td>
          <td class="text-xs-center">
            {{ (props.item.totaltasks - props.item.closetasks) | numberFormat }}
          </td>
          <td class="text-xs-center">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-chip
                  color="green"
                  text-color="white"
                  v-if="props.item.status"
                  disabled
                  small
                  v-on="on"
                >
                  <v-avatar> <v-icon>check</v-icon> </v-avatar>เข้างาน
                </v-chip>
                <v-chip color="red" text-color="white" v-else disabled small v-on="on">
                  <v-avatar> <v-icon>close</v-icon> </v-avatar>ออกงาน
                </v-chip>
              </template>
              <span>{{ props.item.statustime | DateFormat('DD MMM YYYY - HH:mm') }}</span>
            </v-tooltip>
          </td>
          <td>
            <v-btn small flat icon>
              <v-icon v-if="props.expanded">keyboard_arrow_down</v-icon>
              <v-icon v-else>keyboard_arrow_up</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>

      <template v-slot:expand="props">
        <v-card flat color="grey lighten-4">
          <v-card-text>
            <p>จำนวนลูกค้าที่ติดต่อ : {{ props.item.totaltasks }}</p>
            <p>จำนวนที่ลูกค้าที่ปิดการขาย : {{ props.item.closetasks }}</p>
            <p>จำนวนที่ลูกค้าที่ยังไม่ปิด : {{ props.item.totaltasks - props.item.closetasks }}</p>
          </v-card-text>
        </v-card>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import api from '@/api'
import moment from 'moment'
export default {
  data() {
    return {
      selectedDate: {
        start: moment().toDate(),
        end: moment().toDate()
      },
      currentFilter: 'today',
      loading: false,
      search: '',
      pagination: {
        descending: true,
        rowsPerPage: 25,
        sortBy: 'status'
      },
      headers: [
        { text: 'ชื่อ', value: 'first_name' },
        { text: 'จำนวนลูกค้าที่ติดต่อ', value: 'totaltasks', width: '1%' },
        { text: 'จำนวนที่ลูกค้าที่ปิดการขาย', value: 'closetasks', width: '1%' },
        { text: 'จำนวนที่ลูกค้าที่ยังไม่ปิด', value: 'closetasks', width: '1%', sortable: false },
        { text: 'สถานะ', value: 'status', align: 'center', width: '1%' },
        { text: '', width: '1%' }
      ],
      admins: [],
      fetchInterval: undefined,
      startdateModal: false
    }
  },
  mounted() {
    var vm = this
    vm.loading = true
    vm.getAdminstatus().then((data) => {
      vm.admins = data
      vm.loading = false
    })
    vm.fetchInterval = setInterval(() => {
      vm.loading = true
      vm.getAdminstatus().then((data) => {
        vm.admins = data
        vm.loading = false
      })
    }, 120000)
  },
  methods: {
    changeDate: function (value) {
      var vm = this
      vm.currentFilter = value
      switch (value) {
        case 'today':
          vm.selectedDate.start = moment().toDate()
          vm.selectedDate.end = moment().toDate()
          vm.onSelectedDate()
          break

        case 'last_month':
          vm.selectedDate.start = moment().subtract(1, 'months').toDate()
          vm.selectedDate.end = moment().toDate()
          vm.onSelectedDate()
          break

        case 'this_month':
          vm.selectedDate.start = moment().startOf('month').toDate()
          vm.selectedDate.end = moment().endOf('month').toDate()
          vm.onSelectedDate()
          break

        case 'this_year':
          vm.selectedDate.start = moment().startOf('year').toDate()
          vm.selectedDate.end = moment().endOf('year').toDate()
          vm.onSelectedDate()
          break

        case 'last_365_day':
          vm.selectedDate.start = moment().subtract(365, 'days').toDate()
          vm.selectedDate.end = moment().toDate()
          vm.onSelectedDate()
          break

        case 'custom_date':
          break
      }
    },
    getAdminstatus() {
      return new Promise((resolve, reject) => {
        let data = {
          datefrom: moment(this.selectedDate.start).format('YYYY-MM-DD'),
          dateto: moment(this.selectedDate.end).format('YYYY-MM-DD')
        }
        api.getAdminstatus(data, function (error, response) {
          if (error) {
            reject(error)
          }
          if (response.data) {
            resolve(response.data)
          }
        })
      })
    },
    onSelectedDate: function (value) {
      var vm = this
      vm.loading = true
      vm.getAdminstatus().then((data) => {
        vm.admins = data
        vm.loading = false
      })
    }
  },
  beforeDestroy() {
    clearInterval(this.fetchInterval)
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/qualityexpress/Admin.vue